import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";
import { ArrowForward } from "@styled-icons/material/ArrowForward";

import CallToAction, { callToActionSurface } from "./CallToAction";
import VisuallyHidden from "./VisuallyHidden";
import { trackReferralLinkClicked } from "../utils/analyticsUtils";

// The estate agent dashboard's referral prompt, in the sidebar (the hamburger menu on small
// screens). When the staff app has resolved a referral code for the signed-in agent, the whole box
// is a link to their referral form (the link is built server-side, see /api/dashboard). Otherwise
// it stays the partnerships mailto it has always been.
//
// The form opens in a new tab so the dashboard stays put, and so the tab's campaign attribution
// (sessionStorage, first landing wins) starts from this link rather than whatever brought the
// agent to the dashboard; rel="noopener" is what guarantees the new tab's storage starts empty.
function ReferralCallToAction({ referralLink }) {
  if (!referralLink) {
    return (
      <CallToAction>
        <h2>Let’s discuss referrals</h2>
        <p>
          <a href="mailto:partnerships@juno.legal">partnerships@juno.legal</a>
        </p>
      </CallToAction>
    );
  }

  return (
    <ReferralLink href={referralLink} target="_blank" rel="noopener noreferrer" onClick={trackReferralLinkClicked}>
      Refer a new client
      <VisuallyHidden> (opens in a new tab)</VisuallyHidden>
      <ArrowIcon aria-hidden="true" />
    </ReferralLink>
  );
}

export default ReferralCallToAction;

ReferralCallToAction.propTypes = {
  referralLink: PropTypes.string,
};

const ReferralLink = styled.a`
  ${callToActionSurface}

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
  padding: 0.875rem 1rem;

  color: var(--juno-color-purple) !important;
  font-size: var(--juno-font-size-body-md);
  font-weight: var(--juno-font-weight-bold);
  line-height: 1.5;
  border-bottom: 0 !important;

  &:hover,
  &:focus-visible {
    filter: brightness(0.96);
  }
`;

const ArrowIcon = styled(ArrowForward)`
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
`;
